import { useEffect, useRef, useState } from "react";
import {
  dismissMobileAppBanner,
  isMobileAppBannerDismissed,
} from "../utils/mobile-app-banner-dismissal";
import { sendMobileAppBannerEvent } from "../utils/mobile-app-banner-events";
import { useMobileAppPromotion } from "./use-mobile-app-promotion.hook";

/**
 * Visibility and actions of the smart app banner. Starts hidden so the
 * server render and the first client render are identical.
 *
 * @example
 * const { intentUrl, isVisible, dismiss } = useMobileAppBanner();
 */
export function useMobileAppBanner() {
  const intentUrl = useMobileAppPromotion();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(isMobileAppBannerDismissed());
  }, []);

  const isVisible = Boolean(intentUrl) && !dismissed;
  const viewSent = useRef(false);

  useEffect(() => {
    if (!isVisible || viewSent.current) return;
    viewSent.current = true;
    sendMobileAppBannerEvent("banner_view");
  }, [isVisible]);

  const dismiss = () => {
    dismissMobileAppBanner();
    setDismissed(true);
  };

  return {
    intentUrl,
    isVisible,
    dismiss,
    trackClick: () => sendMobileAppBannerEvent("banner_click"),
  };
}
